import { render, staticRenderFns } from "./lidao-record.vue?vue&type=template&id=d5c4c20a&scoped=true"
import script from "./lidao-record.vue?vue&type=script&lang=js"
export * from "./lidao-record.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c4c20a",
  null
  
)

export default component.exports